import { render, staticRenderFns } from "./zhiweibing.vue?vue&type=template&id=a4a00508&"
import script from "./zhiweibing.vue?vue&type=script&lang=ts&"
export * from "./zhiweibing.vue?vue&type=script&lang=ts&"
import style0 from "./zhiweibing.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports